/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_DoneInputs */

const en_session_done = /** @type {(inputs: Session_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooked`)
};

const de_session_done = /** @type {(inputs: Session_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekocht`)
};

/**
* | output |
* | --- |
* | "Cooked" |
*
* @param {Session_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_done = /** @type {((inputs?: Session_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_done(inputs)
	return en_session_done(inputs)
});